<div class="app-header-bar">
  <div class="app-header-left">
    <img
      src="/assets/images/nishtechlogo.png"
      alt="nish-logo"
      class="nish-logo"
    />
  </div>
  <div class="app-header-center">
    <h5 class="app-header">NConnect</h5>
  </div>
  <div class="app-header-right">
    <!-- right area reserved for avatar or actions -->
  </div>
</div>
